import LeadStepperStep from './LeadStepperStep.component';

export default LeadStepperStep;
